<template>
    <data-dialog
        :dialog-title="dialog.title"
        :closeOnClickModal = 'false'
        :is-visible="dialog.formVisible"
        ref="userDialog"
        @dgVerifyDeal="dgVerifyDeal('userDialog','dialog')"
        @dgCancelDeal='cancel'
        @dgConfirmDeal="save">
      <div slot="dialogFrom">
        <el-form ref="dialog" :model="dialog.data" :rules="dialogRule"  label-width="80px" label-position="top" class="commonForm">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="姓名" prop="name" style="width: 70%;margin-bottom: 5px">
                        <el-input v-model="dialog.data.name"  placeholder="请输入姓名" maxlength="30" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="性别"  prop="sexCode" style="width: 70%;margin-bottom: 5px">
                        <el-radio-group v-model="dialog.data.sexCode">
                            <el-radio label="0301">男</el-radio>
                            <el-radio label="0302">女</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="手机" prop="mobilephone" style="width: 70%;margin-bottom: 5px">
                        <el-input  v-model.number="dialog.data.mobilephone" placeholder="请输入手机"  minlength="11" maxlength="11" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="电话" prop="telephone" style="width: 70%;margin-bottom: 5px">
                        <el-input v-model="dialog.data.telephone" placeholder="请输入电话" maxlength="30" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="传真" prop="fax" style="width: 70%;margin-bottom: 5px">
                        <el-input v-model="dialog.data.fax" placeholder="请输入传真" maxlength="30" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="QQ" prop="qq" style="width: 70%;margin-bottom: 5px">
                        <el-input v-model.number="dialog.data.qq" placeholder="请输入QQ" maxlength="15" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="邮箱" prop="email" style="width: 70%;margin-bottom: 5px">
                        <el-input v-model="dialog.data.email" placeholder="请输入Eamil" maxlength="30" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="序号" prop="no" style="width: 70%;margin-bottom: 5px">
                        <el-input v-model="dialog.data.no" controls-position="right" :min="0" :maxlength="10" :pattern="pattern" @input="handleInput" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="this.dialog.title ==='用户信息' ">
                <el-col :span="12">
                    <el-form-item label="账号" prop="account" style="width: 70%;margin-bottom: 5px">
                        <el-input v-model="dialog.data.account" placeholder="账号" disabled :minlength="4" maxlength="30" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="密码" style="width: 70%;margin-bottom: 5px">
                        <el-button type="text" @click="getMm">修改密码</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
          <el-row v-if="this.dialog.title ==='新增用户' ">
            <el-col :span="12">
              <el-form-item label="账号" prop="account" style="width: 70%;margin-bottom: 5px">
                <el-input v-model="dialog.data.account" placeholder="账号"  maxlength="30" />
              </el-form-item>
            </el-col>
            <el-col :span="12" >
              <el-form-item label="密码" prop="password" style="width: 70%;margin-bottom: 5px">
                <el-input v-model="dialog.data.password" placeholder="密码"  maxlength="30" show-password/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <data-dialog
                :dialog-title="mmdlgTitle"
                :closeOnClickModal = 'false'
                :is-visible="innerVisible"
                ref="mmDialog"
                @dgVerifyDeal="dgVerifyDeal('mmDialog','mmForm')"
                @dgCancelDeal='mmcancel'
                @dgConfirmDeal="submitForm"
                style="height: 70vh"
               >
          <div slot="dialogFrom">
            <el-form ref="mmForm" :rules="mmRules" :model="mmForm" style="margin-left: 10vw;">
                <el-form-item prop="oldMm" label="旧密码" style="width: 70%;margin-bottom: 5px">
                    <el-input type="password" placeholder="请输入旧密码" autocomplete="off" v-model="mmForm.oldMm"></el-input>
                </el-form-item >
                <el-form-item prop="newMm" label="新密码" style="width: 70%;margin-bottom: 5px">
                    <el-input type="password" placeholder="请输入新密码" autocomplete="off" v-model="mmForm.newMm" ></el-input>
                </el-form-item>
                <el-form-item prop="checkMm" label="确认密码" style="width: 70%;margin-bottom: 5px">
                    <el-input type="password" placeholder="请确认密码"  autocomplete="off" v-model="mmForm.checkMm" ></el-input>
                </el-form-item>
            </el-form>
          </div>
<!--            <div slot="footer" class="dialog-footer">-->
<!--                <el-button @click="innerVisible = false">取 消</el-button>-->
<!--                <el-button type="primary" @click="submitForm('mmForm')">提交</el-button>-->
<!--            </div>-->
        </data-dialog>
      </div>
    </data-dialog>


</template>

<script>
    import DataDialog from "@/components/tableGather/dataDialog.vue";
    import md5 from 'js-md5'
    export default {
        name: "userOpen",
        components:{
          DataDialog
        },
        data(){
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                }else if(this.mmForm.oldMm === value){
                    callback(new Error('新旧密码不能一致!'));
                } else {
                    // if(value.length < 5){
                    //    callback(new Error('长度在 6 到 30 个字符'));
                    // }
                    if (this.mmForm.checkMm !== '') {
                        this.$refs.mmForm.validateField('checkMm');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.mmForm.newMm) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            // 设置手机号的验证规则
          var phoneRules = (rule, value, callback) => {
            if (!value) {
              callback()
            } else {
              // const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/;
              const reg = /^((13\d)|(14[5,7,9])|(15[0-3,5-9])|(166)|(17[0,1,3,5,7,8])|(18[0-9])|(19[8,9]))\d{8}/;
              if (reg.test(value)) {
                callback();
              } else {
                return callback(new Error("请输入正确的手机号码"));
              }
            }
          };
          // 设置qq的验证规则
          var qqRules = (rule, value, callback) => {
            if (!value) {
              callback()
            } else {
              const reg =  /^[1-9][0-9]{4,10}$/;
              if (reg.test(value)) {
                callback();
              } else {
                return callback(new Error("请输入正确的QQ号码"));
              }
            }
          };
          // 设置email的验证规则
          var checkEmail = (rule, value, callback) => {
            if (!value) {
              callback()
            }else {
              const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
              // if (!value) {
              //     return callback(new Error('邮箱不能为空'))
              // }
              if (mailReg.test(value)) {
                callback();
              } else {
                return callback(new Error("请输入正确的邮箱格式"));
              }
            }
          };
          // 设置传真的验证规则
          var faxRules = (rule, value, callback) => {
            if (!value) {
              callback()
            } else {
              const reg =  /(\(\d{3,4}\)|\d{3,4}-|\s)?\d{8}/;
              if (reg.test(value)) {
                callback();
              } else {
                return callback(new Error("请输入正确的传真"));
              }
            }
          };
          // 设置电话的验证规则
          var telephoneRules = (rule, value, callback) => {
            if (!value) {
              callback()
            } else {
              const reg =  /^0\d{2,3}-?\d{7,8}$/;
              if (reg.test(value)) {
                callback();
              } else {
                return callback(new Error("请输入正确的电话号码"));
              }
            }
          };
            return{
                innerVisible:false,
                pattern: /^\d{0,10}$/,
                dialogRule:{
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                    ],
                    sexCode: [
                        { required: true, message: '请选择性别', trigger: 'change' }
                    ],
                    account: [
                      { required: true, message: '请输入账号', trigger: 'blur' },
                      { min: 4, message: '至少输入4位', trigger: 'blur' }
                    ],
                    password: [
                      { required: true, message: '请输入密码', trigger: 'blur' },
                      { min: 4, message: '至少输入4位', trigger: 'blur' }
                    ],
                    mobilephone:[
                        { required: false,validator:phoneRules, trigger: 'blur'}
                    ],
                   telephone: [{required: false, validator: telephoneRules,trigger: 'blur'}],
                    fax: [{ required: false,validator: faxRules,trigger: 'blur'}],
                    qq: [{required: false, validator: qqRules ,trigger: 'blur'}],
                    email:[{ required: false,validator: checkEmail,trigger: 'blur'}]
                },
                mmdlgTitle:'密码修改',
                mmForm: {
                    oldMm:'',
                    newMm:'',
                    checkMm: '',
                },
                oldMm:"",
                mmRules:{
                    oldMm: [
                        { required: true, message: '请输入旧密码', trigger: 'blur' },
                    ],
                    newMm: [
                        {required: true,validator:validatePass,trigger:'blur'}
                    ],
                    checkMm: [
                        { required: true,validator: validatePass2, trigger: 'blur' }
                    ],
                },
            }

        },
        methods:{
          handleInput(){
            // 使用正则表达式检查输入的值是否为数字
            this.dialog.data.no = this.dialog.data.no.replace(/\D/g, '');
            // 如果输入超过10个字符，截取前10个字符
            if (this.dialog.data.no.length > 10) {
              this.dialog.data.no = this.dialog.data.no.slice(0, 10);
            }
          },
          dgVerifyDeal(dgRef, frRef) {
            this.$refs[frRef].validate((valid) => {
              if (valid) {
                this.$refs[dgRef].isShowPop(true);
              } else {
                this.$refs[dgRef].isShowPop(false);
              }
            });
          },
          mmcancel(){
            this.innerVisible=false;
          },
          cancel(){
            this.$emit("reset")
            this.dialog.formVisible = false
            //重置表单值
            this.$refs.dialog.resetFields();
          },
          save(event){

            this.$refs.dialog.validate((valid) => {
                if (valid) {
                    if(this.dialog.title === '新增用户'){
                      const dataPar = {
                        account : this.dialog.data.account,
                        name : this.dialog.data.name,
                        password:md5(this.dialog.data.password),
                        sexCode :this.dialog.data.sexCode,
                        telephone:this.dialog.data.telephone,
                        mobilephone:this.dialog.data.mobilephone,
                        fax:this.dialog.data.fax,
                        qq:this.dialog.data.qq,
                        email:this.dialog.data.email,
                        no:this.dialog.data.no,
                      }
                        this.request.post("/rm-suser/v1", dataPar).then(res => {
                            if (res.ok) {
                                this.dialog.formVisible = false
                                this.$emit("reset")
                                this.$message.success("添加用户完成！")
                            }else{
                              this.$message.error(res.error.message)
                            }
                        })
                    }else{
                        this.request.put("/rm-suser/v1", this.dialog.data).then(res => {
                            if (res.ok) {
                                this.dialog.formVisible = false
                                this.$emit("reset")
                                this.$message.success("修改用户完成！")
                            }
                        })
                    }
                }
            })

          },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            getMm(){
                this.mmForm={
                  oldMm:'',
                  newMm:'',
                  checkMm: ''
                }
                this.innerVisible = true
            },

            submitForm(formName) {
                this.$refs["mmForm"].validate((valid) => {
                    if (valid) {
                            const data = {
                                id:this.dialog.data.id,
                                oldPassword:md5(this.mmForm.oldMm) ,
                                newPassword:md5(this.mmForm.newMm),
                                checkPassword:md5(this.mmForm.checkMm)
                            }
                            this.request.put("/rm-suser/v1/modifyPass", data).then(res => {
                                if(res.ok){
                                    this.$message.success("密码修改成功！")
                                    this.innerVisible = false
                                }else{
                                    this.$message.error(res.error.message)
                                }

                            })

                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });
            },

        },
        props:['dialog']
    }
</script>
<style scoped>
    .commonForm {
      padding-top: 4vh;
      padding-left: 6vw;
    }
    .el-divider--horizontal{
        margin: 12px 0;
    }
</style>
